import React, { useCallback, useMemo } from 'react';
import { useEmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import { DataTable } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/DataTable';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/EmployeeEngagementDashboard.styled';
import { DataTableColumn } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/FulfillmentDashboard.types';
import { formatDashboardNumber } from 'pages/ReportsPage/components/AnalyticsDashboards/formatDashboardNumber';
import { useAnalyticsFilterStore } from 'pages/ReportsPage/store/analyticsFilterView.context';

const COLUMNS: DataTableColumn[] = [
  { key: 'teamMemberName', label: 'Team Member Name' },
  { key: 'position', label: 'Position' },
  { key: 'shiftCount', label: 'Number of shifts', align: 'right', noWrap: true },
  {
    key: 'averageResponseTime',
    label: 'Average Response Time(Hours)',
    align: 'right',
    noWrap: true,
  },
];

export const TopIndividualFulfillmentTable: React.FC = () => {
  const data = useEmployeeEngagementDashboardStore((s) => s.topFulfillment);
  const currentPage = useEmployeeEngagementDashboardStore((s) => s.topFulfillmentPage);
  const totalPages = useEmployeeEngagementDashboardStore((s) => s.topFulfillmentTotalPages);
  const isLoading = useEmployeeEngagementDashboardStore((s) => s.topFulfillmentLoading);
  const hasError = useEmployeeEngagementDashboardStore((s) => s.topFulfillmentError);
  const fetchTopFulfillment = useEmployeeEngagementDashboardStore((s) => s.fetchTopFulfillment);

  const dateRange = useAnalyticsFilterStore((s) => s.dateRange);
  const locationIds = useAnalyticsFilterStore((s) => s.locationIds);
  const positions = useAnalyticsFilterStore((s) => s.positions);
  const employmentTypes = useAnalyticsFilterStore((s) => s.employmentTypes);

  const handlePageChange = useCallback(
    (page: number) => {
      fetchTopFulfillment(page, dateRange, locationIds, positions, employmentTypes);
    },
    [fetchTopFulfillment, dateRange, locationIds, positions, employmentTypes],
  );

  const rows = useMemo(
    () =>
      data?.map((d) => ({
        teamMemberName: d.teamMemberName,
        position: d.position,
        shiftCount: d.shiftCount,
        averageResponseTime: formatDashboardNumber(d.averageResponseTimeHours),
      })) ?? [],
    [data],
  );

  if (hasError) {
    return (
      <EmptyStateContainer>Failed to load top individual fulfillment data</EmptyStateContainer>
    );
  }

  if (!data && !isLoading) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  return (
    <DataTable
      columns={COLUMNS}
      rows={rows}
      ariaLabel="Top individual fulfillment table"
      serverPagination={{
        currentPage,
        totalPages,
        onPageChange: handlePageChange,
        isLoading,
      }}
    />
  );
};
